
const WpForm = (props:any) :JSX.Element => {
    return (
        <div>WpForm</div>
    )
} 

export default WpForm